import React, { Component, useState, useEffect, useRef } from "react";

import styled from "styled-components";
import { Bold16, LinkStyle } from "../components/common";
import Shimmer from "react-shimmer-effect";

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const Profile = styled.div`
  background: ${(props) => props.theme.dull};
  padding: ${(props) =>
    props.errorState ? "32px 16px 0px 16px" : "16px 16px 16px 16px"};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ececec;
`;

function CalendarShimmer(props) {
  return (
    <>
      <Header>
        <Shimmer>
          <div
            style={{
              height: "18px",
              borderRadius: "2px",
              width: "56px",
            }}
          />
        </Shimmer>
      </Header>
      <Profile style={{ background: "white", padding: "10px" }}>
        <div style={{ width: "100%", display: "flex", height: "50px" }}>
          <div style={{ marginRight: "10px" }}>
            <Shimmer>
              <div
                style={{
                  height: "50px",
                  width: "50px",
                  minWidth: "50px",
                  borderRadius: "50%",
                }}
              />
            </Shimmer>
          </div>
          <div
            style={{
              display: "flex",
              flexGrow: "1",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",

                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Shimmer>
                <div
                  style={{
                    width: "50px",
                    height: "20px",

                    // marginLeft: "16px",
                    borderRadius: "2px",
                  }}
                />
                <div
                  style={{
                    width: "60px",
                    height: "20px",

                    // marginLeft: "16px",
                    borderRadius: "2px",
                  }}
                />
              </Shimmer>
            </div>
            <div
              style={{
                display: "flex",

                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Shimmer>
                <div
                  style={{
                    width: "40px",
                    height: "20px",

                    // marginLeft: "16px",
                    borderRadius: "2px",
                  }}
                />
                <div
                  style={{
                    width: "30px",
                    height: "20px",

                    // marginLeft: "16px",
                    borderRadius: "2px",
                  }}
                />
              </Shimmer>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "25px",
          }}
        >
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <div style={{ width: "30px", marginRight: "10px" }}>
              <Shimmer>
                <div
                  style={{
                    width: "100%",
                    height: "12px",
                    borderRadius: "2px",
                  }}
                />
              </Shimmer>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "fit-content",
              }}
            >
              <Shimmer>
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
              </Shimmer>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              marginTop: "8px",
            }}
          >
            <div style={{ width: "30px", marginRight: "10px" }}>
              <Shimmer>
                <div
                  style={{
                    width: "100%",
                    height: "12px",
                    borderRadius: "2px",
                  }}
                />
              </Shimmer>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "fit-content",
              }}
            >
              <Shimmer>
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
                <div
                  style={{
                    width: "34px",
                    height: "15px",
                    borderRadius: "10px",
                    margin: "0 2px 4px 2px",
                  }}
                />
              </Shimmer>
            </div>
          </div>
        </div>
      </Profile>
    </>
  );
}

export default CalendarShimmer;
